// Formulário do responsável pelo orçamento

import React from "react";
import { HiUser } from "react-icons/hi";
import { ResponsavelOrcamento } from "../../../types/orcamento-fornecedor.types";
import { formatCPF } from "../../../utils/orcamento-formatters";

interface FormResponsavelProps {
  data: Partial<ResponsavelOrcamento>;
  onChange: (field: keyof ResponsavelOrcamento, value: string) => void;
  errors: Record<string, string>;
  showErrors?: boolean;
}

export const FormResponsavel: React.FC<FormResponsavelProps> = ({
  data,
  onChange,
  errors,
  showErrors = false,
}) => {
  const handleCPFChange = (value: string) => {
    const formatted = formatCPF(value);
    onChange("cpf", formatted);
  };

  return (
    <div className="border-b border-gray-200 pb-6">
      <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-200">
        <div className="w-10 h-10 rounded-lg bg-[#4760e0]/10 flex items-center justify-center">
          <HiUser className="h-6 w-6 text-[#4760e0]" />
        </div>
        <h2 className="text-xl font-bold text-[#161519]">
          Responsável pelo orçamento
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nome completo <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data.nome || ""}
            onChange={(e) => onChange("nome", e.target.value)}
            className={`w-full px-4 py-2.5 rounded-lg border-2 transition-all outline-none ${
              showErrors && errors.nome
                ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                : "border-gray-200 focus:border-[#4760e0] focus:ring-2 focus:ring-[#4760e0]/20"
            }`}
            placeholder="Digite o nome completo do responsável"
          />
          {showErrors && errors.nome && (
            <p className="text-sm text-red-600 mt-1">{errors.nome}</p>
          )}
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            value={data.email || ""}
            onChange={(e) => onChange("email", e.target.value)}
            className={`w-full px-4 py-2.5 rounded-lg border-2 transition-all outline-none ${
              showErrors && errors.email
                ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                : "border-gray-200 focus:border-[#4760e0] focus:ring-2 focus:ring-[#4760e0]/20"
            }`}
            placeholder="email@empresa.com.br"
          />
          {showErrors && errors.email && (
            <p className="text-sm text-red-600 mt-1">{errors.email}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            CPF <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data.cpf || ""}
            onChange={(e) => handleCPFChange(e.target.value)}
            className={`w-full px-4 py-2.5 rounded-lg border-2 transition-all outline-none font-mono ${
              showErrors && errors.cpf
                ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                : "border-gray-200 focus:border-[#4760e0] focus:ring-2 focus:ring-[#4760e0]/20"
            }`}
            placeholder="000.000.000-00"
            maxLength={14}
          />
          {showErrors && errors.cpf && (
            <p className="text-sm text-red-600 mt-1">{errors.cpf}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            RG
          </label>
          <input
            type="text"
            value={data.rg || ""}
            onChange={(e) => onChange("rg", e.target.value)}
            className={`w-full px-4 py-2.5 rounded-lg border-2 transition-all outline-none ${
              showErrors && errors.rg
                ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                : "border-gray-200 focus:border-[#4760e0] focus:ring-2 focus:ring-[#4760e0]/20"
            }`}
            placeholder="Digite o RG"
          />
          {showErrors && errors.rg && (
            <p className="text-sm text-red-600 mt-1">{errors.rg}</p>
          )}
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Cargo na empresa <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={data.cargo || ""}
            onChange={(e) => onChange("cargo", e.target.value)}
            className={`w-full px-4 py-2.5 rounded-lg border-2 transition-all outline-none ${
              showErrors && errors.cargo
                ? "border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200"
                : "border-gray-200 focus:border-[#4760e0] focus:ring-2 focus:ring-[#4760e0]/20"
            }`}
            placeholder="Ex: Diretor Comercial, Gerente, Sócio..."
          />
          {showErrors && errors.cargo && (
            <p className="text-sm text-red-600 mt-1">{errors.cargo}</p>
          )}
        </div>
      </div>
    </div>
  );
};
